export default __webpack_public_path__ + "static/media/dk.f438aca3.jpg";